const ChatbotLogo = () =>{
    return(
    <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1080 1080" width={'30px'}>
    <defs>
        <style>{`
            .cls-1 {
                fill: #d8b035;
}
        `}</style>
    </defs>
    <g>
        <path className="cls-1" d="M685.63,370.46l111.26,196.75h-124.31l-85.05-196.75h98.1" />
        <path className="cls-1" d="M528.25,370.46l85.05,196.75h-341.08l85.1-196.75h170.92" />
        <path className="cls-1" d="M199.95,370.46h98.1l-85.05,196.75h-124.31l111.26-196.75" />
        <path className="cls-1" d="M88.69,606.53h123.82l151.24,309.49c1.81,3.84-3.34,7.24-6.14,4.06L88.69,606.53" />
        <path className="cls-1" d="M270.91,606.53h343.76l-168.46,391.25c-1.21,2.96-5.54,2.96-6.74,0l-168.56-391.25" />
        <path className="cls-1" d="M521.84,916.02l151.24-309.49h123.82l-268.91,313.44c-2.8,3.29-8.01-.11-6.14-3.95" />
    </g>
    <path className="cls-1" d="M602.48,274.42c157.85,8.7,186.88,35.57,194.42,194.42,8.7-157.85,35.56-186.88,194.42-194.42-157.85-8.7-186.88-35.56-194.42-194.42-8.7,157.85-35.56,186.88-194.42,194.42Z" />
</svg>)
}
export default ChatbotLogo